'use client';

import * as React from 'react';
import { useAtomValue } from 'jotai';
import { copyrightAtom } from '../../../_components/design-state';

export const COPYRIGHT_STYLES = 'site-copyright';

export function Copyright() {
  const copyright = useAtomValue(copyrightAtom);
  const hasP = copyright.includes('</p>');
  const Wrapper = hasP ? 'div' : 'p';
  return (
    <Wrapper
      className={COPYRIGHT_STYLES}
      dangerouslySetInnerHTML={{ __html: copyright }}
    />
  );
}
